






































































import { Component, Vue } from "vue-property-decorator";
import { PageInfo } from "@/model/Resp";
import {
  getEmailClickCampaign
} from "@/services/api";
import {TFormVO} from "@/model/FormWheel";


@Component({})
export default class wheelOfFortuneList extends Vue {
  tableData: TFormVO[] = [];

  pageInfo: PageInfo = {
    currentPage: 1,
    pageSize: 20,
    total: 0,
  };

  order = null
  prop = null
  totalClickCount = 0
  totalUniqueClickCount = 0


   created(): void {
    this.getEmailClick()

  }

  async getEmailClick (){
    let {data ,status} = await getEmailClickCampaign({
      "campaignId": this.$route.params.id,
      "pageSize": this.pageInfo.pageSize,
      "sortColumn": this.prop,
      "sortType": this.order && (this.order === 'ascending'? 'ASC' :'DESC'),
      "currentPage": this.pageInfo.currentPage,
    },true)
    if(status === 200 ){
      this.tableData = data.data.details
      this.totalUniqueClickCount = data.data.totalUniqueClickCount
      this.totalClickCount = data.data.totalClickCount
      this.pageInfo = data.data.pageInfo as PageInfo
    }
  }



  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  sortChange(data:any){
    this.order = data?.order
    this.prop = data?.prop
    this.getEmailClick();
  }


  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.pageInfo.pageSize = val;
    this.pageInfo.currentPage = 1;
    this.getEmailClick();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.pageInfo.currentPage = val;
    this.getEmailClick();
  }

  clickURL(val:string){
    window.open(val)
  }

}
